import { useGetTeamQuery } from "../../../features/Team/teamApi";
export default function Team() {
  const { isError, data, isLoading } = useGetTeamQuery();

  return (
    <div className="mt-8">
      <h3 className="text-xl font-bold">Team Members</h3>
      <div className="mt-3 space-y-4">
        {isLoading && <p>Loading...</p>}
        {isError && <p>Error</p>}
        {data &&
          data.map((member) => (
            <div className="checkbox-container">
              <img
                src={`/assets${member.avatar}`}
                className="team-avater"
                alt="team member"
              />
              <p className="label">{member.name}</p>
            </div>
          ))}
      </div>
    </div>
  );
}
